<template>
  <div style="position: relative">
    <!-- <el-button
      style="position: fixed; right: 100px; top: 200px; z-index: 99"
      type="primary"
      @click="toPagelist"
      >去列表</el-button
    > -->
    <section id="service-area" class="service-area section-padding-lg bg-white">
      <div class="container">
        <div class="row">
          <div
            class="col-xl-8 offset-xl-2 col-lg-10 offset-lg-1 col-12 offset-0"
          >
            <div class="section-title text-center">
              <h6>Jiangsu Tianzhou Testing Technology Co., Ltd.</h6>
              <h2>江苏天宙检测科技有限公司</h2>
              <p v-html="content1.content"></p>
              <!-- 精于品质，专于服务，创⼀流检测品牌 -->
              <!-- {{ content1.content }} -->
              <el-button
                v-if="content1.content"
                @click="handleEdit(1, content1)"
                type="primary"
                class="toEdit"
                size="mini"
              >
                编辑子标题
              </el-button>
              <el-button
                @click="handleEdit(5, content5)"
                type="primary"
                class="toEdit"
                size="mini"
              >
                编辑内容
              </el-button>
              <!-- <el-button
                  v-else
                  @click="handleEdit(1, content1)"
                  type="primary"
                  class="toEdit"
                  size="mini"
                >
                  新增
                </el-button> -->
            </div>
          </div>
        </div>
        <div class="row align-items-center">
          <div class="col-xl-12 col-lg-12 order-2 order-lg-1">
            <div class="about-content">
              <!-- <h6>COMPANY INTRODUCTION</h6> -->
              <!-- <h2>
                公司简介 -->

              <!-- </h2> -->
              <div v-html="content5.content"></div>
            </div>
          </div>

          <!-- <div class="col-xl-7 col-lg-6 order-1 order-lg-2">
            <div class="about-image text-center wow fadeInRight" data-tilt>
              <img :src="getImgUrl(content5.imagePath)" alt="about thumb" />
            </div>
           
          </div> -->
        </div>
        <div class="row justify-content-center services-grid">
          <!-- Signle Service -->
          <div
            class="col-lg-4 col-md-6 col-sm-6 col-12"
            v-for="(item, index) in content2"
            :key="index"
          >
            <div class="service text-center">
              <div class="service-icon">
                <span>
                  <i class="bi bi-tools"></i>
                </span>
                <span>
                  <i class="bi bi-tools"></i>
                </span>
              </div>
              <!-- <div class="service-icon">
                  <span>
                    <i class="bi bi-finger-print"></i>
                  </span>
                  <span>
                    <i class="bi bi-finger-print"></i>
                  </span>
                </div> -->
              <div class="service-content">
                <h4 v-html="item.title"></h4>
                <!-- 检测设备种类 -->
                <!-- {{ item.title }} -->
                <el-button
                  v-if="item.content"
                  @click="handleEdit(2, item)"
                  type="primary"
                  class="toEdit"
                  size="mini"
                >
                  编辑
                </el-button>
                <!-- <el-button
                    v-else
                    @click="handleEdit(2, content2[0])"
                    type="primary"
                    class="toEdit"
                    size="mini"
                  >
                    新增
                  </el-button> -->

                <p v-html="item.content"></p>
                <!-- 涵盖塔式起重机、⼈货两⽤施⼯升降机、货⽤施⼯升降机（物料提升机）、附着式升降脚⼿架、⾼处作业吊篮、桩⼯机械、⻔式起重机、桥式起重机、履带起重机、汽⻋起重机、轮胎起重机、擦窗机、架桥机、升降⼯作平台
                  、挖掘机、施⼯升降机防坠安全器、安全锁、起重机安全监控管理系统、⼯业货架、脚⼿架、⾮道路柴油移动机械尾⽓等⼆⼗余种检测种类。 -->
                <!-- {{ item.content }} -->
              </div>
            </div>
          </div>
          <!--// Signle Service -->
        </div>
      </div>
    </section>
    <!-- About Area -->
    <!-- <section id="about-area" class="about-area section-padding-lg bg-white">
      <div class="container">
  
      </div>
    </section> -->
    <!--// Service Area -->
    <!-- Pricing Area -->
    <section id="pricing-area" class="pricing-area bg-grey section-padding-lg">
      <div class="container">
        <div class="row">
          <div
            class="col-xl-8 offset-xl-2 col-lg-10 offset-lg-1 col-12 offset-0"
          >
            <div class="section-title text-center">
              <h6>PRODUCT SERVICES AND SOLUTIONS</h6>
              <h2>
                产品服务与解决方案
                <!-- {{ content3.title }} -->
              </h2>
              <p v-html="content3.content"></p>
              <!-- 公司专注于检测检查安全服务，秉持满⾜客户需求服务社会的使命，保持着精于品质、专于服务、创⼀流检测品牌的精神，以客户为中⼼、以质量为基础、以管理控风险、以创新谋发展，做到科学检测、准确判定、公正报告、社会满意。 -->
              <el-button
                v-if="content3.content"
                @click="handleEdit(3, content3)"
                type="primary"
                class="toEdit"
                size="mini"
              >
                编辑
              </el-button>
            </div>
          </div>
        </div>
        <!-- <div class="row justify-content-center">
          <div
            class="col-lg-4 col-md-6"
            style="position: relative"
            v-for="(item, index) in content4"
            :key="index"
          >
            <article class="cr-pricebox" :class="index == 1 ? 'is-active' : ''">
              <el-button
                style="position: absolute; right: 0; top: 0"
                @click="handleEdit(4, item)"
                type="primary"
                class="toEdit"
                size="mini"
              >
                编辑
              </el-button>
              <h4 v-html="item.title"></h4>

              <ul>
                <li v-html="item.content"></li>
              </ul>
            </article>
          </div>
        </div> -->
      </div>
    </section>
    <!--// Pricing Area -->

    <!-- Page Content -->

    <!--// About Area -->

    <!-- team Area -->
    <section
      id="portfoio-area"
      class="portfolio-area section-padding-lg bg-grey"
    >
      <div class="container">
        <div class="row">
          <div
            class="col-xl-8 offset-xl-2 col-lg-10 offset-lg-1 col-12 offset-0"
          >
            <div class="section-title text-center">
              <h6>OUR TEAM</h6>
              <h2>
                <!-- 我们的团队 -->
                我们的团队
                <!-- {{ content6.title }} -->
              </h2>
              <el-button
                @click="handleEdit(6, content6)"
                type="primary"
                class="toEdit"
                size="mini"
              >
                编辑
              </el-button>
              <el-button
                @click="handleEditTeampnhot"
                type="primary"
                class="toEdit"
                size="mini"
              >
                去编辑团队照片
              </el-button>
              <p v-html="content6.content"></p>
              <!-- 公司现有⼈员48⼈，高级职称5⼈，硕博8⼈，持证⼈员30余⼈，其中4⼈持有特种设备检验师证。公司高度重视⼈才队伍建设，具备完善的项目管理程序、岗位职责制度、检测作业流程，建立了⼀套完善的内部⼈员ABCD等级认定、外部安全培训讲座、检测检查效果评估及反馈体系。 -->
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="portfolio-wrap" v-if="content6.imagePath">
        <div class="team-portfolios row">
          <div
            class="col-xl-4 col-lg-6 col-md-6 portfolio-single"
            v-for="(item, index) in splitJoin(content6.imagePath)"
            :key="index"
          >
            <div class="portfolio">
              <div class="portfoilo-thumb">
                <img :src="getImgUrl(item)" alt="portfolio thumb" />
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </section>

    <div class="counter-area half-translate">
      <div class="counter-area-inner bg-theme">
        <div class="container">
          <div class="row no-gutters align-items-center">
            <div class="col-lg-3 col-md-12">
              <div class="counter-content">
                <el-button
                  v-if="content8"
                  style="position: absolute; right: 0; top: 0; z-index: 999"
                  @click="handleEdit(8, content8)"
                  type="primary"
                  class="toEdit"
                  size="mini"
                >
                  编辑
                </el-button>
                <h1 v-html="content8.title"></h1>

                <h4 v-html="content8.content"></h4>
              </div>
            </div>
            <div
              class="col-lg-3 col-md-4"
              v-for="(item, index) in content9"
              :key="index"
            >
              <div class="counter text-center">
                <div class="flex-center">
                  <el-button
                    style="position: absolute; right: 0; top: 0; z-index: 999"
                    @click="handleEdit(9, item)"
                    type="primary"
                    class="toEdit"
                    size="mini"
                  >
                    编辑
                  </el-button>
                  <h1 class="counter-active" v-html="item.title"></h1>
                  <!-- 300-->
                  <!-- {{ item.title }} -->

                  <h1>+</h1>
                </div>
                <h6 v-html="item.content"></h6>
                <!-- 与300余家企事业单位合作 -->
                <!-- {{ item.content }} -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <main class="page-content">
        <!-- About Page Area -->
        <div class="syuanection-title text-center">
          <h2>企业愿景</h2>
          <el-button @click="handleAdd(10)" type="success" class="toEdit">
            新增
          </el-button>
        </div>
        <section class="services-area bg-white">
          <div class="row justify-content-center">
            <!-- Signle Service -->

            <div
              class="col-lg-4 col-md-6 col-sm-6 col-12"
              v-for="(item, index) in content10"
              :key="index"
            >
              <div class="service text-center">
                <div class="service-icon">
                  <span>
                    <img :src="getImgUrl(item.imagePath)" alt="" srcset="" />
                  </span>
                  <span>
                    <img :src="getImgUrl(item.imagePath)" alt="" srcset="" />
                  </span>
                </div>
                <div class="service-content">
                  <h4>{{ item.title }}</h4>
                  <p>
                    {{ item.content }}
                  </p>
                </div>
                <div>
                  <el-button
                    v-if="item.id"
                    @click="handleEdit(10, item)"
                    type="primary"
                    class="toEdit"
                    size="mini"
                  >
                    编辑
                  </el-button>
                  <el-button
                    v-if="item.id"
                    @click="handleDelete(item)"
                    type="danger"
                    class="toEdit"
                    size="mini"
                  >
                    删除
                  </el-button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
    <div>
      <!-- <div class="page-content">
        <div class="section-title text-center">
          <h2>天宙学堂</h2>
        </div>
        <section class="services-area section-padding-lg bg-white">
          <MyEditor ref="editor" key="k" v-model="content11.content" />
          <div class="row justify-content-center">
            <el-button
              @click="handleEdit(11, content11)"
              type="primary"
              class="toEdit"
              size="mini"
            >
              编辑
            </el-button>
          </div>
        </section>
      </div> -->
    </div>
    <!-- Blogs Area -->
    <!-- <section id="blogs-area" class="blogs-area section-padding-lg bg-white">
      <div class="container">
        <div class="row">
          <div
            class="col-xl-8 offset-xl-2 col-lg-10 offset-lg-1 col-12 offset-0"
          >
            <div class="section-title text-center">
              <h6>TYPICAL CASES</h6>
              <h2>经典案例</h2>
            </div>
          </div>
        </div>
        <div
          class="row case-block justify-content-center"
          v-if="content7 && content7.length > 0"
        >
          <div
            class="col-lg-4 col-md-6"
            v-for="(item, index) in content7"
            :key="index"
          >
            <article class="blog" style="position: relative">
              <el-button
                style="position: absolute; right: 0; top: 0; z-index: 999"
                @click="handleEdit(7, item)"
                type="primary"
                class="toEdit"
                size="mini"
              >
                编辑
              </el-button>
              <div class="blog-thumb">
                <a>
                  <img :src="getImgUrl(item.imagePath)" alt="blog thumb" />
                </a>
              </div>
              <div class="blog-content">
                <h5>
                  <p>{{ item.content }}</p>
                </h5>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section> -->
    <!--// Blogs Area -->
    <!-- Brand Logo Area -->
    <div id="brand-logo-area" class="brand-logo-area bg-grey">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div
              class="brand-logos brand-logo-carousel-activation cr-slider-navigation-2 cr-border-bottom"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <Edit
      :state="editState"
      @close="editState = false"
      :row="editUnit"
      @confirm="changeDict"
    />
  </div>
</template>
<script>
import {
  addList,
  updateList,
  getId,
  pageList,
  deleteById
} from '@/api/webofficial'
// import MyEditor from './components/MyEditor.vue'

// import TzTable from '@/components/tz-table/Index.vue'
import Edit from './components/Edit'
import '@/assets/css/officialweb.css'
import '@/assets/css/bootstrap.min.css'
export default {
  components: {
    Edit
    // MyEditor
  },
  data() {
    return {
      // showApi: 'http://192.168.16.36:8092/file',
      showApi: 'http://192.168.16.36:8092/file',
      teamList: [],
      editUnit: {},
      content1: {},
      photoUrl: '',
      content2: [],
      content3: '',
      content4: [],
      content5: '', //公司简介
      content6: '', //我们的团队
      content7: [], //经典案例
      content8: '', //数字成绩
      content9: [], //数字成绩
      content10: [], //企业愿景
      content11: '', //天宙学堂
      editState: false
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    // 列表
    getList() {
      // this.$loading({
      //   text: '查询中'
      // })

      pageList({ pageNum: 1, pageSize: 10000 }).then((res) => {
        if (res.code == 200) {
          // this.$loading().close()
          if (res.data.records && res.data.records.length > 0) {
            let datalist = res.data.records
            this.content2 = []
            this.content4 = []
            this.content7 = []
            this.content9 = []
            this.content10 = []
            datalist.forEach((ele) => {
              if (ele.type == 1) {
                // 公司口号
                this.content1 = ele
              } else if (ele.type == 2) {
                this.content2.push(ele)
              } else if (ele.type == 3) {
                this.content3 = ele
              } else if (ele.type == 4) {
                this.content4.push(ele)
              } else if (ele.type == 5) {
                // 公司简介
                this.content5 = ele
              } else if (ele.type == 6) {
                // 我们的团队
                this.content6 = ele
              } else if (ele.type == 8) {
                // 数字成绩
                this.content8 = ele
              } else if (ele.type == 9) {
                // 数字成绩
                this.content9.push(ele)
              } else if (ele.type == 10) {
                // 企业愿景
                this.content10.push(ele)
              } else if (ele.type == 11) {
                // 天宙学堂
                this.content11 = ele
                this.$refs.editor.html = ele.content
              }
              //   else if (ele.type == 7) {
              //     // 经典案例
              //     this.content7.push(ele)
              //   }
            })
            console.log(this.content7)
          }

          // this.dictList = dictArr
          // if(datalist)
        }
        // else {
        //   this.$loading().close()
        // }
      })
    },
    // 新增
    handleAdd(type) {
      this.$router.push({
        path: '/webofficial/Create',
        query: { type: type }
      })
    },
    // 编辑
    handleEdit(type, row) {
      console.log(row)
      row.type = type
      this.editUnit = JSON.parse(JSON.stringify(row))

      // 显示弹框
      this.editState = true
    },
    // 删除
    handleDelete(row) {
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let delparams = {
            id: row.id
          }
          deleteById(delparams).then((res) => {
            console.log(res, '删除')
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.getList()
            } else {
              this.$message({
                type: 'error',
                message: '删除失败!'
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 字符串转数组
    splitJoin(str) {
      if (str) {
        return str.split(',')
      } else {
        return []
      }
    },
    toPagelist() {
      this.$router.push({
        path: '/webofficial/Pagelist'
      })
    },
    handleEditTeampnhot() {
      this.$router.push({
        path: '/ourteam'
      })
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      // let deviceRow = []
      // let deviceIds = []
      this.reset()
      // const id = row.id || this.ids
      getId({ id: row }).then((response) => {
        let formData = response.data
        // deviceIds.push(row.deviceId)
        // deviceRow.push({ id: row.deviceId, propertyNum: row.propertyNum })
        // this.form.deviceIds = deviceRow
        // this.open = true
        // this.title = '修改设备检测记录'
        if (
          formData.type !== '' &&
          formData.type !== null &&
          formData.type !== undefined
        ) {
          formData.type = Number(formData.type)
        }
        if (formData.imagePath) {
          this.photoList.push({
            url: this.getImgUrl(formData.imagePath)
          })
        }
        this.formData = formData
        console.log(this.photoList)
      })
    },
    // 新增/编辑
    changeDict(infos) {
      console.log(infos)
      this.$loading({
        text: '信息更新中'
      })
      let params = {
        ...infos
      }
      if (infos.id == null || infos.id == null || infos.id == undefined) {
        addList(params).then((res) => {
          console.log(res.data, '创建')
          if (res.code == 200) {
            this.editState = false
            this.$message({
              message: '添加成功',
              type: 'success'
            })
            this.getList()
          } else {
            this.$message({
              message: res.data,
              type: 'error'
            })
          }
        })
        // this.$loading().close()
      } else {
        updateList(params).then((res) => {
          console.log(res.data, '创建')
          if (res.code == 200) {
            this.editState = false
            this.$message({
              message: '修改成功',
              type: 'success'
            })
            this.getList()
          } else {
            this.$message({
              message: res.data,
              type: 'error'
            })
          }
        })
        // this.$loading().close()
      }

      setTimeout(() => {
        this.$loading().close()
      }, 1000)
    }
  }
}
</script>
<style lang="scss" scoped>
.toEdit {
  margin-left: 10px;
}
</style>
